export const reportCarburetion3Types = {
  SET_CARBURETION3_FILTERS: 'SET_CARBURETION3_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
